import React from 'react';
import { SectionWrapper } from './ui';
import { StarIcon, ShieldCheckIcon } from 'lucide-react';
const TestimonialCard = ({
  name,
  location,
  role,
  text
}: {
  name: string;
  location: string;
  role?: string;
  text: string;
}) => <div className="bg-dark-card border border-dark-border rounded-2xl p-6 shadow-lg" data-id="element-270">
    <div className="flex text-accent mb-4" data-id="element-271">
      {[...Array(5)].map((_, i) => <StarIcon key={i} size={18} fill="currentColor" data-id="element-272" />)}
    </div>
    <p className="text-gray-300 italic mb-6 leading-relaxed" data-id="element-273">"{text}"</p>
    <div data-id="element-274">
      <p className="text-white font-bold" data-id="element-275">{name}</p>
      <p className="text-sm text-gray-500" data-id="element-276">
        📍 {location} {role && `· ${role}`}
      </p>
    </div>
  </div>;
export const TestimonialsSet1 = () => {
  const testimonials = [{
    name: 'Valentina M.',
    location: 'Buenos Aires',
    text: 'Antes aceptaba mascotas de palabra. Ahora tengo contrato, ficha y protocolo para todo.'
  }, {
    name: 'Carolina P.',
    location: 'Córdoba',
    text: 'Subí mis precios un 40% en 30 días. Los clientes no se fueron. Se quedaron todos.'
  }];
  return <SectionWrapper className="bg-dark-bg" data-id="element-277">
      <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-278">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-279" />)}
      </div>
    </SectionWrapper>;
};
export const TestimonialsSet2 = () => {
  const testimonials = [{
    name: 'Martín S.',
    location: 'Buenos Aires',
    text: 'Tuve un perro con golpe de calor. Actué exactamente como decía el protocolo. El veterinario me dijo que hice todo bien.'
  }, {
    name: 'Luciana P.',
    location: 'La Plata',
    text: 'Mis clientes preguntaban por qué era más cara. Les mostraba el contrato y la ficha. Dejaban de preguntar y firmaban.'
  }, {
    name: 'Diego F.',
    location: 'Rosario',
    text: 'Cierro consultas en 5 minutos con los textos del bono de WhatsApp. Antes tardaba horas en pensar qué decir.'
  }];
  return <SectionWrapper className="bg-dark-bg" data-id="element-280">
      <div className="text-center mb-12" data-id="element-281">
        <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-282">
          ❤️ MÁS CUIDADORES QUE YA LO TIENEN
        </h2>
      </div>
      <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-283">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-284" />)}
      </div>
    </SectionWrapper>;
};
export const Guarantee = () => {
  return <SectionWrapper className="bg-dark-card/50 border-y border-dark-border" data-id="element-285">
      <div className="max-w-3xl mx-auto text-center" data-id="element-286">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-primary/10 text-primary rounded-full mb-8" data-id="element-287">
          <ShieldCheckIcon size={40} data-id="element-288" />
        </div>
        <h2 className="text-3xl md:text-5xl font-black text-white mb-6" data-id="element-289">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>
        <p className="text-xl text-gray-300 mb-4" data-id="element-290">
          Abrís los tomos. Los usás en tu próximo servicio.
        </p>
        <p className="text-2xl font-bold text-white" data-id="element-291">
          Si en 7 días no es lo que esperabas: <br data-id="element-292" />
          <span className="text-primary" data-id="element-293">devolución del 100%</span> <br data-id="element-294" />
          <span className="text-gray-400 text-lg font-normal" data-id="element-295">
            sin formularios, sin drama.
          </span>
        </p>
      </div>
    </SectionWrapper>;
};